import React from "react";
import style from "./Policy.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

const Policy: React.FC = () => {
  return (
    <PageLayout className={style.Policy}>
      <h1 className={style.Title}>Polityka prywatności</h1>

      <p>
        Niniejsza Polityka prywatności opisuje zasady przetwarzania danych
        osobowych użytkowników serwisu CARTENA, dostępnego pod adresem
        www.cartena.pl.
      </p>

      <h2 className={style.SectionTitle}>
        1. Administrator danych osobowych
      </h2>

      <p>
        Administratorem danych osobowych jest podmiot prowadzący serwis
        CARTENA. Dane identyfikacyjne administratora oraz sposób kontaktu
        w sprawach dotyczących ochrony danych osobowych:
      </p>

      <p>
        CARTENA Paweł Świeć
        <br />
        ul. Ptasia 18, 80-035 Gdańsk
        <br />
        kontakt@cartena.com.pl
      </p>

      <h2 className={style.SectionTitle}>
        2. Jakie dane zbieramy?
      </h2>

      <p>
        Podczas korzystania z serwisu możemy przetwarzać następujące dane:
      </p>

      <ul>
        <li>
          Dane konta użytkownika, w szczególności adres e-mail oraz
          informacje niezbędne do logowania i obsługi konta.
        </li>
        <li>
          Dane publikowane w wizytówkach firm, takie jak nazwa firmy,
          adres, NIP, numer telefonu, adres e-mail, strona internetowa
          oraz opis świadczonych usług.
        </li>
        <li>
          Dane przekazywane podczas kontaktu z administratorem serwisu.
        </li>
        <li>
          Dane techniczne związane z korzystaniem z serwisu, w tym
          adres IP, jeśli jest rejestrowany przez serwer.
        </li>
        <li>
          Dane dotyczące zamówionych usług i płatności, jeśli użytkownik
          korzysta z płatnych funkcji serwisu.
        </li>
      </ul>

      <h2 className={style.SectionTitle}>
        3. W jakim celu przetwarzamy dane?
      </h2>

      <p>
        Dane osobowe mogą być przetwarzane w następujących celach:
      </p>

      <ul>
        <li>Rejestracja, logowanie i obsługa kont użytkowników.</li>
        <li>Publikowanie i zarządzanie wizytówkami firm transportowych.</li>
        <li>Realizacja zamówionych usług, w tym usług płatnych.</li>
        <li>Obsługa zapytań i korespondencji z użytkownikami.</li>
        <li>Zapewnienie bezpieczeństwa i prawidłowego działania serwisu.</li>
        <li>Wypełnianie obowiązków wynikających z przepisów prawa.</li>
      </ul>

      <p>
        W zależności od celu przetwarzania podstawą prawną może być
        wykonanie umowy lub działania przed jej zawarciem (art. 6 ust. 1
        lit. b RODO), obowiązek prawny (art. 6 ust. 1 lit. c RODO),
        prawnie uzasadniony interes administratora (art. 6 ust. 1
        lit. f RODO) albo zgoda użytkownika (art. 6 ust. 1 lit. a RODO),
        jeżeli jest wymagana.
      </p>

      <h2 className={style.SectionTitle}>
        4. Dane publikowane w katalogu
      </h2>

      <p>
        Serwis CARTENA umożliwia prezentowanie informacji o firmach
        transportowych i świadczonych przez nie usługach.
      </p>

      <p>
        Dane zamieszczone w publicznej wizytówce firmy mogą być widoczne
        dla wszystkich odwiedzających serwis, również bez logowania.
        Dotyczy to między innymi nazwy firmy, danych kontaktowych,
        lokalizacji i opisu działalności.
      </p>

      <h2 className={style.SectionTitle}>
        5. Logowanie i localStorage
      </h2>

      <p>
        Serwis wykorzystuje pamięć lokalną przeglądarki (localStorage)
        do przechowywania tokenu uwierzytelniającego. Token umożliwia
        rozpoznanie zalogowanego użytkownika i korzystanie z funkcji
        wymagających logowania.
      </p>

      <p>
        Dane zapisane w localStorage pozostają w przeglądarce do czasu
        ich usunięcia przez aplikację lub użytkownika. Sposób usuwania
        tokenu podczas wylogowania zależy od działania mechanizmu
        logowania w serwisie.
      </p>

      <h2 className={style.SectionTitle}>
        6. Pliki cookies
      </h2>

      <p>
        Serwis wykorzystuje plik cookie służący do zapamiętania decyzji
        użytkownika dotyczącej komunikatu o plikach cookies.
      </p>

      <p>
        Pliki cookies oraz inne technologie przechowywania informacji
        w przeglądarce mogą być wykorzystywane w zakresie niezbędnym
        do prawidłowego działania serwisu.
      </p>

      <p>
        Użytkownik może zarządzać plikami cookies w ustawieniach
        swojej przeglądarki, w tym usuwać zapisane pliki cookies.
      </p>

      <h2 className={style.SectionTitle}>
        7. Komu mogą być udostępniane dane?
      </h2>

      <p>
        Dane mogą być przekazywane podmiotom wspierającym działanie
        serwisu, w szczególności dostawcom hostingu, infrastruktury
        informatycznej, bazy danych oraz usług związanych z obsługą
        płatności, jeżeli uczestniczą w przetwarzaniu danych.
      </p>

      <p>
        Dane mogą być również udostępniane uprawnionym organom, jeżeli
        wymagają tego obowiązujące przepisy prawa.
      </p>

      <p>
        Administrator nie sprzedaje danych osobowych użytkowników.
      </p>

      <h2 className={style.SectionTitle}>
        8. Jak długo przechowujemy dane?
      </h2>

      <p>
        Dane są przechowywane przez okres niezbędny do realizacji celów,
        dla których zostały zebrane, w szczególności przez czas
        korzystania z konta lub świadczenia usług.
      </p>

      <p>
        Niektóre dane mogą być przechowywane dłużej, jeżeli wymagają
        tego przepisy prawa, obowiązki księgowe lub potrzeba ustalenia,
        dochodzenia bądź obrony roszczeń.
      </p>

      <h2 className={style.SectionTitle}>
        9. Prawa użytkownika
      </h2>

      <p>
        W zakresie przewidzianym przez RODO użytkownikowi przysługuje
        prawo do:
      </p>

      <ul>
        <li>Dostępu do swoich danych osobowych.</li>
        <li>Sprostowania nieprawidłowych danych.</li>
        <li>Usunięcia danych, jeżeli zachodzą odpowiednie przesłanki.</li>
        <li>Ograniczenia przetwarzania danych.</li>
        <li>Przenoszenia danych, w przypadkach przewidzianych prawem.</li>
        <li>Wniesienia sprzeciwu wobec przetwarzania danych.</li>
        <li>Wycofania zgody, jeżeli przetwarzanie opiera się na zgodzie.</li>
      </ul>

      <p>
        Użytkownik ma również prawo wniesienia skargi do Prezesa
        Urzędu Ochrony Danych Osobowych (UODO).
      </p>

      <h2 className={style.SectionTitle}>
        10. Bezpieczeństwo danych
      </h2>

      <p>
        Administrator stosuje środki techniczne i organizacyjne
        mające na celu ochronę danych osobowych przed nieuprawnionym
        dostępem, utratą lub nieuprawnioną zmianą.
      </p>

      <h2 className={style.SectionTitle}>
        11. Zmiany Polityki prywatności
      </h2>

      <p>
        Polityka prywatności może być aktualizowana w związku ze
        zmianami w funkcjonowaniu serwisu lub obowiązujących
        przepisach prawa. Aktualna wersja dokumentu jest publikowana
        na stronie CARTENA.
      </p>

      <h2 className={style.SectionTitle}>
        12. Kontakt
      </h2>

      <p>
        W sprawach dotyczących przetwarzania danych osobowych można
        skontaktować się z administratorem serwisu poprzez dane
        kontaktowe wskazane w punkcie 1.
      </p>
    </PageLayout>
  );
};

export default Policy;